import { CartLineItem } from '@src/quince-site-common/src/services/cartService/cart.service.types'

import { getCustomAttributes, getLineItemDetails } from '../../../../hooks/cart/hooks/new-cart-helper'

export interface LineItemDetails {
  mergeOption: string
  productLink: string
  internalVariantId: number | null
  internalProductId: number
  color?: string
  price?: number
}

export const getCartConfig = (lineItems: CartLineItem[]) => {
  const lineItemDetails = getLineItemDetails(lineItems)

  return {
    lineItemDetails,
  }
}

export const isLineItemNodeFreeProduct = (lineItemNode: CartLineItem) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (getCustomAttributes(lineItemNode) || []).findIndex(customAttribute => customAttribute.key === '_FREE_SWATCH_') !==
    -1
  )
}

export const attrWithoutUnderscore = (str: string) => {
  if (str.startsWith('_')) {
    return str.substring(1)
  }
  return str
}

export const stripHtml = (str: string, withSpaces = false) => {
  return str.replace(/(<([^>]+)>)/gi, withSpaces ? ' ' : '')
}
